import { trpc } from "../trpc";
import { useCallback } from "react";

interface Input {
  folderId: string;
}

export function useGenerateAiNotesFromFolderAssetsDebugPayload({
  folderId,
}: Input) {
  const mutation =
    trpc.folder.generateAiNotesFromFolderAssetsDebugPayload.useMutation();
  const { mutateAsync, isPending, error } = mutation;

  const generateAiNotesFromFolderAssetsDebugPayload = useCallback(
    () =>
      mutateAsync({
        folderId,
      }),
    [folderId, mutateAsync],
  );

  return {
    generateAiNotesFromFolderAssetsDebugPayload,
    isGenerating: isPending,
    error,
  };
}
